module.exports = __webpack_public_path__ + "img/erweima-1.4f2fa4f8.png";